import { useContext, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { TranscriptMediaPlayerContext } from '@/containers/Transcript/context';

type SeekingElementsMap = { element: Element; s: number };

export function useFirstLoadSeek() {
  const location = useLocation();
  const initialized = useRef(false);

  const player = useContext(TranscriptMediaPlayerContext);

  const search = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const query = {
    s: +search.get('s') || null,
  };

  useEffect(() => {
    initialized.current = false;
  }, [query.s]);

  useEffect(() => {
    if (!initialized.current && query.s) {
      const nodes: SeekingElementsMap[] = [];
      document.querySelectorAll(`div[data-ts-s]`).forEach((element) => {
        nodes.push({
          element: element,
          s: +element.getAttribute('data-ts-s') || null,
        });
      });

      let closest: SeekingElementsMap | null = null;

      if (nodes.length > 0) {
        closest = nodes.reduce((prev, curr) => {
          return Math.abs(curr.s - query.s) < Math.abs(prev.s - query.s) ? curr : prev;
        });
      } else {
        const monologueNodes: SeekingElementsMap[] = [];
        document.querySelectorAll(`[data-monologue-s]`).forEach((element) => {
          monologueNodes.push({
            element,
            s: +element.getAttribute('data-monologue-s') || null,
          });
        });
        if (monologueNodes.length > 0) {
          closest = monologueNodes.reduce((prev, curr) => {
            return Math.abs(curr.s - query.s) < Math.abs(prev.s - query.s) ? curr : prev;
          });
        }
      }

      if (closest) {
        const scrollTarget = closest.element.hasAttribute('data-monologue-s')
          ? closest.element
          : closest.element.parentElement;
        setTimeout(() => {
          if (player) {
            player.currentTime = query.s;
          }
          console.log('Seeking to', query.s, 'and scrolling to element', scrollTarget);
          scrollTarget.scrollIntoView({ behavior: 'smooth' });
        }, 0);
        initialized.current = true;
      }
    }
  }, [query.s, player]);
}
